initial = true;

document.addEventListener('DOMContentLoaded', () => {
  if (!initial) return;

  const sliders = document.querySelectorAll('.ProductsSlider__swiper');
  const simpleSliders = document.querySelectorAll('.SimpleProductsSlider__swiper');

  sliders.forEach((instance) => {
    let checkSwiperLoadedInterval = setInterval(function() {
      if (typeof Swiper !== undefined && instance) {
        new Swiper(instance, {
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: 20,
          loop: true,
          loopAdditionalSlides: 1,
          activeIndex: 1,
          navigation: {
            nextEl: `#next-${instance.getAttribute('id')}`,
            prevEl: `#prev-${instance.getAttribute('id')}`,
          }
        });
        clearInterval(checkSwiperLoadedInterval);
      }
    }, 200);
  })

  simpleSliders.forEach((instance) => {
    let checkSwiperLoadedInterval = setInterval(function() {
      if (typeof Swiper !== undefined && instance) {
        new Swiper(instance, {
          direction: 'horizontal',
          slidesPerView: 'auto',
          spaceBetween: 20,
          loop: false,
          loopAdditionalSlides: 1,
          activeIndex: 1,
          navigation: {
            nextEl: `#next-${instance.getAttribute('id')}`,
            prevEl: `#prev-${instance.getAttribute('id')}`,
          }
        });
        clearInterval(checkSwiperLoadedInterval);
      }
    }, 200);
  })

  if (initial) initial = false;
})